import styled from 'styled-components';

import { ActionButton, breakpoints } from '@notino/react-styleguide-v20';

import { IBasicTestProps } from '@styles/model';
import { CypressTestNamespace } from '@utils/test';

import { ETextAlignment } from './model';

interface IStyledMessageLineProps {
  bold: boolean;
}

export const StyleMessageLine = styled.div<IStyledMessageLineProps>`
  font-weight: ${({ bold }: IStyledMessageLineProps) => (bold ? 'bold' : 'normal')};
`;

interface IStyledHeaderLineProps extends IStyledMessageLineProps {
  fontSize: number;
}

export const StyledHeaderLine = styled(StyleMessageLine)<IStyledHeaderLineProps>`
  margin-bottom: 1rem;
  line-height: normal;
  font-size: ${({ fontSize }) => fontSize}rem;
`;

export const StyledWarningModal = styled.div.attrs<IBasicTestProps>(() => ({
  className: CypressTestNamespace.ECartPageModals.WARNING_MODAL,
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
`;

interface IStyledWarningModalContentProps {
  textAlign: ETextAlignment;
}

export const StyledWarningModalContent = styled.div<IStyledWarningModalContentProps>`
  text-align: ${({ textAlign }) => textAlign};
  font-size: 0.875rem;
  margin-bottom: 1.3125rem;
`;

export const StyledActionButton = styled(ActionButton)`
  display: block;
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    margin: 0 auto;
    width: auto;
    min-width: 7rem;
  }
`;
